import {Component, AfterViewInit, ViewChild} from '@angular/core';
import {NewWorkflowComponent} from './new-workflow/new-workflow.component';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {SelectionModel} from '@angular/cdk/collections';
import {Toast} from 'app/shared/toast/toast';
import {IdexService} from 'app/idex.service';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {merge, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {MatSort} from '@angular/material/sort';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {ShareComponent} from '../share/share.component';


@Component({
   selector: 'app-workflow',
   templateUrl: './workflow.component.html',
   styleUrls: ['./workflow.component.css']
})
export class WorkflowComponent implements AfterViewInit {
   isLoadingResults = false;
   isLoadingResultsShare = false;
   isRateLimitReached = false;
   isRateLimitReachedShare = false;
   showTabShare = false;
   resultsLength = 0;
   resultsLengthShare = 0;
   selectTabIndex = 0;
   errorMessage: any;
   private newWorkflow: MatDialogRef<NewWorkflowComponent>;

   clickActive: boolean;
   selectedRowIndex: number;
   displayedColumns = ['select', 'no', 'workflow_name', 'last_update_date', 'active', 'menu'];
   displayedColumnsShare = ['no', 'workflow_name', 'create_by' , 'last_update_date'];
   wfDataSource: MatTableDataSource<WorkflowList>;
   wfDataSourceShare: MatTableDataSource<WorkflowList>;
   private share: MatDialogRef<ShareComponent>;
   selection = new SelectionModel<WorkflowList>(true, []);
   workflowData: WorkflowList[] = [];
   workflowDataShare: WorkflowList[] = [];
   filterWfValue: any;
   filterWfValueShare: any;
   pageSize = 50;
   pageSizeShare = 50;
   tabType: string;
   searching: any;
   searchingShare: any;
   searchFocused: boolean;
   searchFocusedShare: boolean;
   preventBlur: boolean;
   preventBlurShare: boolean;
   searchResult: any[];
   searchResultShare: any[];
   searchvalue: any;
   searchvalueShare: any;
   private timer: any;

   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(PaginatorComponent, {static: true}) paginatorShare: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild('sortShare') sortShare: MatSort;
   @ViewChild('btnDel', {static: true}) public buttonDel: MatButton;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;

   constructor(protected service: IdexService,
               private dialog: MatDialog,
               public toast: Toast,
               public translate: TranslateService) {

   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.clickActive = false;
         this.buttonDel.disabled = true;

         this.getWorkflowList();
         this.getWorkflowListShare();
      }, 0);
   }

   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.tabType = 'M';
      } else if (indexSelected === 1) {
         this.tabType = 'S';
      }
      setTimeout(() => {
         if (this.selectTabIndex === 0) {
            this.searching = '';
            this.filterWfValue = '';
            this.getWorkflowList();
         }
         if (this.selectTabIndex === 1) {
            this.searchingShare = '';
            this.filterWfValueShare = '';
            this.getWorkflowListShare();
         }
      }, 100);
      this.selection.clear();
      this.buttonDel.disabled = true;
   }

   getWorkflowList() {
      this.loader.show();

      merge(this.paginator.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResults = true;
               if (this.paginator.size !== undefined) {
                  this.pageSize = this.paginator.size;
               }

               if (this.filterWfValue === undefined) {
                  this.filterWfValue = '';
               }

               let sort = 'workflow_name';
               let order = 'asc';
               if (this.sort) {
                  sort = this.sort.active;
                  order = this.sort.direction;
               }

               return this.service.getWorkflowAll(
                  this.pageSize, this.paginator.page, sort, order, encodeURIComponent(this.filterWfValue), 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.selectedRowIndex = -1;
               this.selection.clear();
               this.buttonDel.disabled = true;
               this.resultsLength = data.totalCount;
               this.workflowData = data.items;
               this.wfDataSource = new MatTableDataSource(this.workflowData);
               if (this.paginator.page !== data.pageIndex) {
                  this.paginator.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResults = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReached = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.wfDataSource.data = data);
   }

   getWorkflowListShare() {
      this.loader.show();

      merge(this.paginatorShare.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResultsShare = true;
               if (this.paginatorShare.size !== undefined) {
                  this.pageSizeShare = this.paginatorShare.size;
               }

               if (this.filterWfValueShare === undefined) {
                  this.filterWfValueShare = '';
               }

               let sort = 'workflow_name';
               let order = 'asc';
               if (this.sortShare) {
                  sort = this.sortShare.active;
                  order = this.sortShare.direction;
               }

               return this.service.getWorkflowShare(
                  this.pageSizeShare, this.paginatorShare.page, sort, order, encodeURIComponent(this.filterWfValueShare), 'f', 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResultsShare = false;
               this.isRateLimitReachedShare = false;
               this.selectedRowIndex = -1;
               this.selection.clear();
               this.buttonDel.disabled = true;
               this.resultsLengthShare = data.totalCount;
               this.workflowDataShare = data.items;
               if (this.workflowDataShare.length !== 0) {
                  this.showTabShare = true;
               }
               this.wfDataSourceShare = new MatTableDataSource(this.workflowDataShare);
               if (this.paginatorShare.page !== data.pageIndex) {
                  this.paginatorShare.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResultsShare = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReachedShare = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.wfDataSourceShare.data = data);
   }

   activeTemplate(id: any, name: any, active: any , row: any) {
      this.clickActive = true;
      const wfId = id.innerHTML;
      const wfName = name.innerHTML;
      const activeFlg = active.checked;
      if (activeFlg === false) {
         this.service.activeWorkflow(wfId, wfName)
            .subscribe((response) => {
               this.toast.success(response);
               this.getWorkflowList();
            });
      } else {
         this.service.inactiveWorkflow(wfId, wfName)
            .subscribe((response) => {
               this.toast.warn(response);
               if (row.shareId !== 0) {
                  this.service.unshare(row.workflowId, 'WF')
                     .subscribe(
                        () => {
                           this.getWorkflowList();
                        },
                        error => {
                           this.errorMessage = error;
                        });
               } else {
                  this.getWorkflowList();
               }
            });
      }
   }

   highlight(row) {
      if (!this.clickActive) {
         this.selectedRowIndex = row.no;

         this.openNewWorkflow();
         this.newWorkflow.componentInstance.id = row.workflowId;
         this.newWorkflow.componentInstance.wfNameValue = row.workflowName;
         this.newWorkflow.componentInstance.getWorkflow();
         this.newWorkflow.componentInstance.mode = 'edit';
      }
      this.clickActive = false;
   }

   highlightShare(row) {
      if (!this.clickActive) {
         this.selectedRowIndex = row.no;

         this.openNewWorkflow();
         this.newWorkflow.componentInstance.id = row.workflowId;
         this.newWorkflow.componentInstance.wfNameValue = row.workflowName;
         this.newWorkflow.componentInstance.taskAttribute.viewMode = true;
         this.newWorkflow.componentInstance.getWorkflow();
         this.newWorkflow.componentInstance.mode = 'edit';
      }
      this.clickActive = false;
   }

   onSearch(input: any, filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterWfValue = filterValue;
         this.getWorkflowList();
         input.blur();
      }
   }

   onSearchShare(input: any, filterValue: string) {
      this.searchFocusedShare = false;
      this.searchvalueShare = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterWfValueShare = filterValue;
         this.getWorkflowListShare();
         input.blur();
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocusedShare = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchChangeShare(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResultShare = null;
      this.searchChangeShare(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchBlurShare() {
      setTimeout(() => {
         if (!this.preventBlurShare) {
            this.searchFocusedShare = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchFocusShare(input: any) {
      this.searchFocusedShare = true;
      this.searchChangeShare(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getWorkflowAll(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data;
                  }
               });
      }, 300);
   }

   searchChangeShare(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getWorkflowShare(0, 0, '',
            '', kw, 't', 'f')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResultShare = data;
                  }
               });
      }, 300);
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.wfDataSource.data.length;

      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return numSelected === numRows;

   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggle() {
      if (this.isAllSelected()) {
         this.selection.clear();
         this.buttonDel.disabled = true;
      } else {
         this.wfDataSource.data.forEach(row => this.selection.select(row));
         this.buttonDel.disabled = false;
      }
   }

   disableButton(row: any) {
      const numSelected = this.selection.selected.length;
      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return this.selection.isSelected(row);

   }

   deleteWorkflow() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.workflow').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const IdList: number[] = [];
            for (let i = 0; i < this.selection.selected.length; i++) {
               IdList.push(this.selection.selected[i].workflowId);
            }
            this.service.deleteWorkflow(IdList)
               .subscribe((response) => {
                  this.toast.success(response);
                  this.selection.clear();
                  this.getWorkflowList();
                  this.getWorkflowListShare();
               });
         }
      });
   }

   openNewWorkflow() {
      this.newWorkflow = this.dialog.open(NewWorkflowComponent, {
         disableClose: true,
         data: this,
         width: '1200px',
         minHeight: '550px',
         maxHeight: '1000px'
      });

      this.newWorkflow.afterClosed().subscribe(result => {
         if (result) {
            this.getWorkflowList();
            this.getWorkflowListShare();
         }
      });
   }

   tabShare(row) {
      if (row.shareId !== 0) {
         this.service.getAllShare(row.shareId)
            .subscribe((data: any) => {
               this.share.componentInstance.shareGroup = data.group;
               this.share.componentInstance.shareUser = data.contact;
               this.share.componentInstance.shareSites = data.sites;
               this.share.componentInstance.membersShare = data.UserShares;
               this.share.componentInstance.groupShare = data.GroupShare;
               this.share.componentInstance.siteShare = data.SiteShares;
            }, error => {
               this.errorMessage = error;
            });
      }
      if (!this.clickActive) {
         this.share = this.dialog.open(ShareComponent, {
            disableClose: true,
            data: this,
            width: '600px'
         });
         this.share.componentInstance.objectId = row.workflowId;
         this.share.componentInstance.shareId = row.shareId;
         this.share.componentInstance.objectType = 'WF';
         this.share.afterClosed().subscribe(result => {
            this.getWorkflowList();
            this.getWorkflowListShare();
         });
      }
      this.clickActive = false;
   }
}

export interface WorkflowList {
   no: number;
   workflowId: number;
   workflowName: string;
   active: boolean;
   createDate: string;
   createBy: string;
   lastUpdateDate: string;
   lastUpdateBy: string;
   shareId: any;
}
